import { gql, useMutation } from '@apollo/client'

import { SetOrganizationDiscountForm } from '../types'

interface Result {
  setOrganizationDiscount: boolean
}

const mutation = gql`
  mutation SetOrganizationDiscount($storeId: ID!, $organizationId: ID!, $percent: Decimal) {
    setOrganizationDiscount(storeId: $storeId, organizationId: $organizationId, percent: $percent)
  }
`

const useSetOrganizationDiscount = () => {
  const [mutate] = useMutation<Result, SetOrganizationDiscountForm>(mutation)

  return (variables: SetOrganizationDiscountForm) => mutate({ variables })
}

export default useSetOrganizationDiscount
